import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { ThemeType } from '../../utils'

type Props = {
  size?: number | string
}

export const AuroraCareSessionsSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as ThemeType
  const { auroraIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 96 96' fill='none'>
      <Rect width='96' height='96' rx='48' fill='white' fillOpacity='0.4' />
      <Path
        d='M34.951 42.9241C34.951 42.9241 24.4812 38.9108 21.3841 49.3297C18.2871 59.7487 28.2862 63.7035 38.055 60.2856C47.8239 56.8677 54.5515 46.6553 59.5807 48.4073C64.6098 50.1592 68.7985 30.3918 52.996 29.3248C36.2763 28.1924 34.9545 42.9276 34.9545 42.9276L34.951 42.9241Z'
        fill={auroraIllustration.primary.fill}
      />
      <Path
        d='M40.401 67.2959C39.7897 67.2959 39.6045 66.4666 40.153 66.203C42.9161 64.8712 47.2161 62.4359 48.9068 59.5192C51.4848 55.0739 55.5334 42.8553 66.2085 44.1485C74.9553 45.2098 78.8851 57.3405 72.828 63.9259C70.809 66.1222 67.9166 67.2959 64.9404 67.2959H40.401Z'
        fill={auroraIllustration.secondary.fill}
      />
    </Svg>
  )
}
